<template>
    <div class="drug-grid">
        <div class="drug-grid-wrapper">
            <div class="drug-grid-header">
                <span class="dgh-col">序号</span>
                <span class="dgh-col dgh-name">{{ isChaowei ? '品名' : '药品' }}</span>
                <span class="dgh-col dgh-weight">{{ isChaowei ? '数量（包）' : '重量（克）' }}</span>
                <span class="dgh-col">序号</span>
                <span class="dgh-col dgh-name">{{ isChaowei ? '品名' : '药品' }}</span>
                <span class="dgh-col dgh-weight">{{ isChaowei ? '数量（包）' : '重量（克）' }}</span>
                <!-- <span class="dgh-col dgh-action">更换</span> -->
            </div>
            <div class="drug-grid-body">
                <div class="drug-grid-row" v-for="(item, idx) in pane.options" :key="'row-' + idx">
                    <span class="dg-index" v-if="item.key"><span>{{ item.index }}</span></span>
                    <span class="dg-name-text" v-if="item.key">{{ item.key }}</span>
                    <span class="dg-weight-text" v-if="item.key">{{ item.value }}<template
                            v-if="!isChaowei">g</template></span>
                    <span class="dg-index" v-if="item.key1 != null && item.key1 !== ''"><span>{{ item.index1
                            }}</span></span>
                    <span class="dg-name-text" v-if="item.key1 != null && item.key1 !== ''">{{ item.key1 }}</span>
                    <span class="dg-weight-text" v-if="item.key1 != null && item.key1 !== ''">{{ item.value1 }}<template
                            v-if="!isChaowei">g</template></span>
                    <!--
                    <span class="dg-action">
                        <el-button class="dg-replace-btn" @click="$emit('drug-change', item, 0)" size="small">更换</el-button>
                        <el-button class="dg-replace-btn" @click="$emit('drug-weight', item, 0)" size="small">改重</el-button>
                    </span>
                    <span class="dg-action">
                        <el-button class="dg-replace-btn" @click="$emit('drug-change', item, 1)" size="small">更换</el-button>
                        <el-button class="dg-replace-btn" @click="$emit('drug-weight', item, 1)" size="small">改重</el-button>
                    </span>
                    -->
                </div>
            </div>
        </div>
        <div class="drug-grid-summary">
            <span class="summary-asterisk">*</span>总计：<b>{{ pane.count }}</b><template
                v-if="isChaowei">种</template><template v-else>味</template><span
                v-if="pane.charge != 0 && !pane.isHandmade">，<template v-if="isChaowei"><b>{{ pane.totalWeight }}</b>包；参考价格：<b>{{ pane.charge
                    }}元/副</b></template><template v-else><b>{{ pane.totalWeight }}</b>克；参考药价：<b>{{ pane.charge
                    }}元/副</b></template></span>
        </div>
        <div class="granules-summary" v-if="pane.isHandmade && (pane.decoctionTotalWeight || pane.totalWeight)">
            <span class="summary-asterisk">*</span>饮片重量：<b>{{ pane.decoctionTotalWeight || pane.totalWeight }}</b>克<span
                v-if="(pane.decoctionPrice || pane.charge) != 0">；参考药价：<b>{{ pane.decoctionPrice || pane.charge
                    }}元/副</b></span>
        </div>
        <div class="granules-summary" v-if="pane.isHandmade && config.showGranules && pane.granulesTotalWeight">
            <span class="summary-asterisk">*</span>颗粒重量：<b>{{ pane.granulesTotalWeight }}</b>克<span
                v-if="pane.granulesSumPrice != 0">；参考药价：<b>{{ pane.granulesSumPrice }}元/副</b></span>
        </div>
        <div class="drug-grid-footer" v-if="config.showSupplyDays !== false">
            <span class="summary-asterisk">*</span>
            <span v-if="consultInfo.ganZhiPrescriptionHourRange && config.showGanZhi">有效使用期：<b>{{ pane.startDate }} {{
                consultInfo.ganZhiPrescriptionHourRange }}</b></span>
            <span v-else>有效使用期：<b>{{ pane.startDate }} ~ {{ pane.endDate }}，<template
                    v-if="isChaowei">该方案</template><template v-else>该处方</template>有效期{{ pane.supplyDays }}天。</b></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrescriptionTable',
    props: {
        pane: { type: Object, default: () => ({}) },
        consultInfo: { type: Object, default: () => ({}) },
        config: {
            type: Object,
            default: () => ({
                showSupplyDays: true,
                chaoweiMode: false,
            }),
        },
    },
    computed: {
        // 是否超微饮品场景（替换表头/汇总/有效期文案）
        isChaowei() {
            return !!(this.config && this.config.chaoweiMode);
        },
    },
}
</script>

<style scoped>
/* ========== Grid 药品表格 ========== */
.drug-grid {
    width: 100%;
    background: transparent;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
}

.drug-grid-wrapper {
    overflow: hidden;
    border: 1px solid #dfeae3;
    border-radius: 12px;
    background: #ffffff;
}

/* 表头 */
.drug-grid-header {
    display: grid;
    grid-template-columns: 1fr 1.5fr 1fr 1fr 1.5fr 1fr;
    background: #20863F;
    padding: 14px 0;
}

.dgh-col {
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
}

.dgh-col:not(:first-child) {
    border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.dgh-name {
    text-align: left;
    padding-left: 20px;
}

.dgh-weight {
    text-align: center;
}

/* 行 */
.drug-grid-body {
    display: flex;
    flex-direction: column;
}

.drug-grid-row {
    display: grid;
    grid-template-columns: 1fr 1.5fr 1fr 1fr 1.5fr 1fr;
    align-items: center;
    border-bottom: 1px solid #edf2ee;
    background: #ffffff;
    padding: 0;
    min-height: 56px;
}

.drug-grid-row:last-child {
    border-bottom: none;
}

.drug-grid-row:hover {
    background: #f8faf7;
}

.drug-grid-row> :not(:first-child) {
    border-left: 1px solid #edf2ee;
}

/* 序号 */
.dg-index {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
}

.dg-index span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid #ef4444;
    color: #ef4444;
    font-size: 18px;
    font-weight: 600;
}

/* 药品名 */
.dg-name-text {
    font-size: 18px;
    font-weight: 500;
    color: #1f3327;
    padding: 14px 20px;
}

/* 重量 */
.dg-weight-text {
    font-size: 16px;
    font-weight: 700;
    color: #20863F;
    padding: 14px 0;
    text-align: center;
}

/* 操作列（占位用） */
.dg-action {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 14px 0;
}

/* 更换按钮 */
.dg-replace-btn {
    font-size: 12px;
    padding: 4px 10px;
    height: 26px;
    border-color: #20863F;
    color: #20863F;
    opacity: 1;
    transition: opacity 0.2s;
}

.dg-replace-btn:hover {
    background: #20863F;
    color: #fff;
    border-color: #20863F;
}

/* 汇总行 */
.drug-grid-summary {
    background: #ffffff;
    padding: 14px 24px;
    font-size: 18px;
    border-radius: 0 0 12px 12px;
    border-top: 1px solid #edf2ee;
}

.drug-grid-summary b {
    color: #ef4444;
    font-weight: 700;
}

.granules-summary {
    background: #ffffff;
    padding: 12px 24px;
    font-size: 18px;
    margin-top: 1px;
    border-top: 1px solid #edf2ee;
}

.granules-summary b {
    color: #ef4444;
    font-weight: 700;
}

.summary-asterisk {
    color: #ef4444;
    font-weight: 700;
}

/* 底部（有效期） */
.drug-grid-footer {
    background: #ffffff;
    padding: 12px 24px;
    font-size: 18px;
    margin-top: 1px;
    border-top: 1px solid #edf2ee;
    border-radius: 12px;
}

.drug-grid-footer b {
    color: red;
}

/* 移动端药品表格 */
@media (max-width: 768px) {
    .drug-grid-header {
        display: none;
    }

    .drug-grid-row {
        display: grid;
        grid-template-columns: 48px 1fr auto;
        padding: 10px 12px;
        gap: 4px;
        align-items: center;
        min-height: auto;
    }

    .dg-index {
        padding: 0;
        grid-row: span 2;
    }

    .dg-index span {
        width: 30px;
        height: 30px;
        font-size: 13px;
    }

    .dg-name-text {
        padding: 0;
        grid-column: 2;
        font-size: 15px;
    }

    .dg-weight-text {
        padding: 0;
        text-align: left;
        grid-column: 2;
        font-size: 15px;
    }

    .dg-action {
        padding: 0;
        grid-row: span 2;
        grid-column: 3;
        flex-direction: column;
        gap: 4px;
    }

    .dg-replace-btn {
        padding: 2px 8px;
        height: 22px;
        font-size: 11px;
    }
}
</style>
